lmApp
  .controller('OfferController', ['$scope', '$rootScope', '$timeout', '$compile', '$templateCache', '$q', '$routeParams', '$location', 'AssetService', 'MetadataService', 'OfferService', 'GroupService', 'ToastService', 'ManageAssetsWindow',
    function ($scope, $rootScope, $timeout, $compile, $templateCache, $q, $routeParams, $location, AssetService, MetadataService, OfferService, GroupService, ToastService, ManageAssetsWindow) {

      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {UPDATE_OFFER_COLLECTION: 'update.offer.collection'});

      $scope.offerData = [];
      $scope.groupSearch = [];
      $scope.loading = false;
      $scope.activeOffer = {};
      $scope.search = {
        searchField: '',
        isShown: false
      };

      $scope.isActiveOfferSet = function () {
        return !_.isEmpty($scope.activeOffer);
      };

      $scope.toggleSearch = function () {
        $scope.search.isShown = !$scope.search.isShown;
        $timeout(function () {
          angular.element('input#offer_search').focus();
        }, 200);
      };

      $scope.availableCurrencies = [
        {
          title: 'US Dollar',
          id: 'USD'
        },
        {
          title: 'Russian Ruble',
          id: 'RUB'
        }
      ];

      $scope.availableSubscription = [
        {
          label: 'Transactional Permanent (TVOD/DTO)',
          value: 'transactional-own'
        },
        {
          label: 'Transactional Rent (TVOD/DTR)',
          value: 'transactional-rent'
        }
      ];

      function getLocalCurrency(currency) {

        return _.find($scope.availableCurrencies, {id: currency});
      }

      $scope.availableDurationUnits = [
        {
          title: 'Hour(s)',
          id: 'hour'
        },
        {
          title: 'Day(s)',
          id: 'day'
        },
        {
          title: 'Week(s)',
          id: 'week'
        },
        {
          title: 'Month(s)',
          id: 'month'
        },
        {
          title: 'Year(s)',
          id: 'year'
        }
      ];

      function getLocalDurationUnit(durationUnit) {
        var parse;

        parse = _.find($scope.availableDurationUnits, {id: durationUnit});

        if (!parse) {
          parse = null;
        }

        return parse;
      }

      function prepareOffer(offer, index) {
        if (!offer._PrivateData) offer._PrivateData = {};
        offer._PrivateData.validateErrors = {};
        offer._PrivateData.assets = [];
        offer._PrivateData.index = index;

        offer._PrivateData.is_active = !!offer.is_active;
        offer._PrivateData.priority = +offer.priority;
        offer._PrivateData.name = offer.name;
        offer._PrivateData.selectedAsset = [];

        if (offer.type === 'transactional') {

          if (offer.right_params.duration === 0 || !offer.right_params.duration) {
            offer._PrivateData.type = 'transactional-own';
            offer._PrivateData.typeTitle = 'Permanent (TVOD/DTO)';
          } else {
            offer._PrivateData.type = 'transactional-rent';
            offer._PrivateData.typeTitle = 'Rent (TVOD/DTR)';
          }
        } else if (offer.type === 'free') {

          offer._PrivateData.isFree = true;
        }

        offer._PrivateData.billing_params_price = (offer.billing_params.price ? offer.billing_params.price / 100 : '').toString();
        offer._PrivateData.billing_params_currency = getLocalCurrency(offer.billing_params.currency);

        if (offer._PrivateData.billing_params_currency) offer._PrivateData.priceOuput = offer._PrivateData.billing_params_price + ' ' + offer._PrivateData.billing_params_currency.id;

        offer._PrivateData.start_time = moment.utc(offer.start_time * 1000);
        offer._PrivateData.end_time = moment.utc(offer.end_time * 1000);

        offer._PrivateData.right_params_duration = offer.right_params.duration && offer.right_params.duration.toString() || null;
        if (offer.right_params.duration_unit) offer._PrivateData.right_params_duration_unit = getLocalDurationUnit(offer.right_params.duration_unit);

        offer._PrivateData.groupsNew = $scope.groupSearch
          .filter(function (group) {
            return _.includes(offer.group_id, group.id);
          })
          .map(function (group) {
            return {
              title: group.title,
              id: group.id
            }
          });

        return offer;
      }

      $scope.validateFields = MetadataService.ValidateMetadata.Offer;

      $scope.getOfferCollection = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#offersLoader');

        return OfferService.GetOffers()
          .then(function (offers) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#offersLoader');

            $scope.offerData = offers.map(function (offer, index) {
              return prepareOffer(offer, index);
            });

            if (offers.length && $scope.routeOfferId) {
              var offer = _.find(offers, {id: $scope.routeOfferId});

              if (offer) {
                $scope.setActiveOffer(offer);
              }
            }

            return true;
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#offersLoader');

            $rootScope.debugInfo(reason);
            return false;
          })
      };

      $scope.setActiveOffer = function (offer, index) {
        if ($scope.loading) return;

        $scope.direction = 'right';

        $scope.activeOffer = angular.copy(offer);
        $scope.activeOffer = prepareOffer(offer, index);
        $scope.activeOffer._PrivateData.assets = [];
        $scope.activeOffer._PrivateData.selectedAsset = [];
        $location.search('offer_id', offer.id);

        if ($scope.activeOffer.assets.length) {
          $scope.loading = true;
          $rootScope.showLinearProgress('#offersLoader');

          AssetService.GetAssetInId(offer.assets)
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#offersLoader');
              $scope.activeOffer._PrivateData.assets = collection;
            });
        }
      };

      $scope.clearActiveOffer = function () {
        if ($scope.loading) return;

        $scope.activeOffer = {};
        $location.search('offer_id', null);
      };

      $scope.isActiveOffer = function (id) {

        return $scope.activeOffer.id === id;
      };

      $scope.priorityUp = function (offer) {
        ++offer._PrivateData.priority;
      };

      $scope.priorityDown = function (offer) {
        if (offer._PrivateData.priority > 0) --offer._PrivateData.priority;
      };

      $scope.setSubscriptionType = function (offer, type) {
        offer._PrivateData.type = type;
      };

      $scope.saveOfferStatus = function (offer) {
        if ($scope.loading) return;
        if (offer._PrivateData.isNew) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#offersLoader');

        OfferService.UpdateOfferStatus(offer)
          .then(function () {
            $scope.getOfferCollection();
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          })
      };

      $scope.saveOfferOptions = function (offer) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validateFields(offer))) {
          ToastService.Big({
            color: 'amber',
            title: 'Empty fields',
            text: 'Not all required fields are filled. Check all marked fields.',
            icon: 'alert'
          }, 60 * 1000);

          return;
        }

        var allQ = {};
        $scope.loading = true;
        $rootScope.showLinearProgress('#offersLoader');

        if (offer._PrivateData.isFree) {

          offer._PrivateData.type = 'free';
          offer._PrivateData.billing_params_price = 0.01;
          offer._PrivateData.billing_params_currency = $scope.availableCurrencies[0];
        }

        if (offer._PrivateData.isNew) {
          OfferService.CreateOffer(offer)
            .then(function (offer_) {

              var groupIds = offer._PrivateData.groupsNew.map(function (group) {
                return group.id;
              });

              var toAdd = _.difference(groupIds, offer.group_id);

              if (toAdd.length) {
                allQ.groupsAdd = GroupService.AddOffer.bind(this, toAdd, [offer_.id]);
              }

              $q.seqAll(allQ)
                .then(function () {
                  $scope.loading = false;
                  ToastService.Small({
                    title: 'Offer successfully created',
                    color: 'green',
                    icon: 'cloud-outline'
                  }, 1000 * 3);
                  $rootScope.hideLinearProgress('#offersLoader');

                  $location.search('offer_id', offer_.id);
                  $scope.getOfferCollection();
                })
                .catch(function (reason) {
                  $scope.loading = false;
                  ToastService.Small({
                    title: 'Offer creation failed',
                    color: 'red',
                    icon: 'cloud-outline-off'
                  }, 1000 * 3);
                  $rootScope.hideLinearProgress('#offersLoader');
                  $rootScope.debugInfo(reason);
                });
            })
            .catch(function (reason) {
              $scope.loading = false;
              ToastService.Small({
                title: 'Offer creation failed',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 3);
              $rootScope.hideLinearProgress('#offersLoader');
              $rootScope.debugInfo(reason);
            });
        } else {


          allQ.metadata = OfferService.UpdateOffer.bind(this, offer);

          var groupIds = offer._PrivateData.groupsNew.map(function (group) {
            return group.id;
          });

          var toAdd = _.difference(groupIds, offer.group_id);

          var toRemove = _.difference(_.reject(offer.group_id, function (item) {
            return item == '0';
          }), groupIds);

          if (toAdd.length) {
            allQ.groupsAdd = GroupService.AddOffer.bind(this, toAdd, [offer.id]);
            offer.group_id = offer.group_id.concat(toAdd);
          }
          if (toRemove.length) {
            allQ.groupsRemove = GroupService.RemoveOffer.bind(this, toRemove, [offer.id]);
            offer.group_id = _.difference(offer.group_id, toRemove);
          }

          $q.seqAll(allQ)
            .then(function () {
              $scope.loading = false;
              ToastService.Small({
                title: 'Offer successfully updated',
                color: 'green',
                icon: 'cloud-outline'
              }, 1000 * 3);
              $rootScope.hideLinearProgress('#offersLoader');
              $scope.getOfferCollection();
            })
            .catch(function (reason) {
              $scope.loading = false;
              ToastService.Small({
                title: 'Offer update failed',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 3);
              $rootScope.hideLinearProgress('#offersLoader');
              $rootScope.debugInfo(reason);
            });

        }

      };

      $scope.toggleSelection = function (activeOffer, asset) {
        var idx = activeOffer._PrivateData.selectedAsset.indexOf(asset);

        if (!asset._PrivateData.isSelected) {
          asset._PrivateData.isSelected = false;

          if (idx !== -1) {
            activeOffer._PrivateData.selectedAsset.splice(idx, 1);
          }
        } else {
          asset._PrivateData.isSelected = true;

          if (idx === -1) {
            activeOffer._PrivateData.selectedAsset.push(asset);
          }
        }
      };
      
      $scope.selectAll = function (activeOffer) {
        if (activeOffer._PrivateData.selectedAsset.length !== activeOffer._PrivateData.assets.length){
          activeOffer._PrivateData.selectedAsset = [];

          activeOffer._PrivateData.assets.forEach(function (asset) {
            if (!asset._PrivateData) asset._PrivateData = {};
            asset._PrivateData.isSelected = true;
            activeOffer._PrivateData.selectedAsset.push(asset);
          });
        } else {
          activeOffer._PrivateData.assets.forEach(function (asset) {
            asset._PrivateData.isSelected = false;
          });
          activeOffer._PrivateData.selectedAsset = [];
        }
      };

      $scope.removeAssetsFromOffer = function (activeOffer) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#offersLoader');

        var _ids = activeOffer._PrivateData.selectedAsset.map(function (asset) {
          return asset.id;
        });

        OfferService.RemoveAsset([$scope.activeOffer.id], _ids)
          .then(function () {
            $scope.getOfferCollection();
            ToastService.Small({
              title: 'Asset(s) successfully removed',
              color: 'green',
              icon: 'package-up'
            }, 1000 * 3);
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createNewOffer = function () {
        var newOffer = {};

        newOffer.is_active = 0;
        newOffer.billing_params = {};
        newOffer.right_params = {};
        newOffer.group_id = [];
        newOffer.priority = 0;
        newOffer._PrivateData = {};
        newOffer._PrivateData.isNew = true;
        newOffer.start_time = moment.utc().unix();
        newOffer.end_time = moment.utc().unix();

        $scope.activeOffer = prepareOffer(newOffer);
        $scope.activeOffer._PrivateData.index = -1;
      };

      $scope.manageAssetsFromOffer = function (toAdd, toRemove, toThis) {
        if ($scope.loading) return;

        var allQ = {};

        if (toAdd.length) {
          var addIds = toAdd.map(function (asset) {
            return asset.id;
          });

          allQ.add = OfferService.AddAsset([toThis.id], addIds);
        }

        if (toRemove.length) {
          var removeIds = toRemove.map(function (asset) {
            return asset.id;
          });

          allQ.remove = OfferService.RemoveAsset([toThis.id], removeIds);
        }

        return allQ;
      };

      $scope.openModal = function (offer) {
        if (!offer._PrivateData.isNew) {

          ManageAssetsWindow.OpenManageAssetsWindow({
            manageAssetsFn: $scope.manageAssetsFromOffer,
            obj: offer,
            index: offer._PrivateData.index,
            data: 'offer',
            title: offer.title,
            currentCollection: _.map(offer._PrivateData.assets, 'id'),
            filter: {
              live: true
            }
          })

        } else {
          ToastService.Small({
            title: 'You should create offer first',
            color: 'amber',
            icon: 'alert'
          }, 1000 * 3);
        }
      };

      GroupService.GetGroups()
        .then(function (collection) {

          $scope.groupSearch = collection.map(function (group) {
            return {
              title: group.name,
              id: group.id
            }
          });
        })
        .catch(function (reason) {
          $scope.loading = false;
          $rootScope.hideLinearProgress('#activePackageLoader');
          $rootScope.debugInfo(reason, 'silent');
          ToastService.Small({
            title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
            color: 'amber',
            icon: 'server-off',
            blocked: true
          }, 1000 * 3);
        });

      if (!$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_OFFER_COLLECTION] || !$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_OFFER_COLLECTION].length) {
        $rootScope.$on($rootScope.EVENTS.UPDATE_OFFER_COLLECTION, function (event) {
          $scope.getOfferCollection();
        });
      }

      $timeout(function () {
        var body = document.body;
        var html = document.documentElement;

        var height = Math.max(body.scrollHeight, body.offsetHeight,
          html.clientHeight, html.scrollHeight, html.offsetHeight);

        angular.element('#offer_data').css({
          height: height
        });
      });

      $scope.routeOfferId = null;
      if ($routeParams.offer_id) {
        $scope.routeOfferId = Number($routeParams.offer_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeOfferId && !$routeParams.offer_id) {
          $scope.clearActiveOffer();
        }
        $scope.routeOfferId = Number($routeParams.offer_id) || null;
      });

      $scope.groupWatcher = $scope.$watchCollection('groupSearch', function (newValue, oldValue) {

        $scope.offerData.forEach(function (offer, index) {

          prepareOffer(offer, index);
        });

        if (!_.isEmpty($scope.activeOffer)) {

          $scope.activeOffer = prepareOffer($scope.activeOffer, $scope.activeOffer.index);
        }
      });

      /**
       * Init collection on controller add
       */
      $rootScope.$broadcast($rootScope.EVENTS.UPDATE_OFFER_COLLECTION);

      $scope.$on('$destroy', function () {
        $rootScope.$$listeners[$rootScope.EVENTS.UPDATE_OFFER_COLLECTION] = [];
      })
    }]);
